<template>
    <svg
        viewBox="0 0 743 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="69.5"
            cy="99.5"
            r="49.5"
            stroke="currentColor"
            stroke-width="40"
        />
        <path
            d="M20 100L20 200"
            stroke="currentColor"
            stroke-width="40"
        />
        <line
            x1="167"
            y1="100"
            x2="167"
            y2="169"
            stroke="currentColor"
            stroke-width="40"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M249.928 38.5521C240.009 33.1008 228.617 30 216.5 30C178.116 30 147 61.1162 147 99.5C147 99.6668 147.001 99.8334 147.002 99.9999H187.004C187.001 99.8336 187 99.667 187 99.5C187 83.2076 200.208 70 216.5 70C219.53 70 222.453 70.4567 225.204 71.305C230.319 58.2384 238.948 46.9335 249.928 38.5521Z"
            fill="currentColor"
        />
        <circle
            cx="296.5"
            cy="99.5"
            r="49.5"
            stroke="currentColor"
            stroke-width="40"
        />
        <circle
            cx="443.5"
            cy="99.5"
            r="49.5"
            stroke="currentColor"
            stroke-width="40"
        />
        <line
            x1="493"
            x2="493"
            y2="100"
            stroke="currentColor"
            stroke-width="40"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M619.659 105C617.492 119.157 605.262 130 590.5 130C574.208 130 561 116.792 561 100.5C561 84.2076 574.208 71 590.5 71C591.003 71 591.503 71.0126 592 71.0375V31.0159C591.501 31.0053 591.001 31 590.5 31C552.116 31 521 62.1162 521 100.5C521 138.884 552.116 170 590.5 170C627.372 170 657.538 141.287 659.857 105H619.659Z"
            fill="currentColor"
        />
        <line
            y1="-20"
            x2="100"
            y2="-20"
            transform="matrix(0 -1 -1 0 668 100)"
            stroke="currentColor"
            stroke-width="40"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M743 169.786C741.185 169.928 739.351 170 737.5 170C699.116 170 668 138.884 668 100.5C668 100.333 668.001 100.167 668.002 100H708.004C708.001 100.166 708 100.333 708 100.5C708 116.792 721.208 130 737.5 130C739.38 130 741.218 129.824 743 129.488V169.786Z"
            fill="currentColor"
        />
        <line
            x1="688"
            y1="69"
            x2="743"
            y2="69"
            stroke="currentColor"
            stroke-width="40"
        />
    </svg>
</template>
